export class VisualizationHistogramSeries {
    'name';
    'data';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<VisualizationHistogramTimePoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VisualizationHistogramSeries.attributeTypeMap;
    }
    constructor() {
    }
}
